import { lazy } from 'react';

import { Permission } from '@infrastructure/authorization/constants';
import { RoutesType, Path } from '@router/types';

const HomePage = lazy(() => import('./home'));
const CasesPage = lazy(() => import('./cases'));
const CreateCasePage = lazy(() => import('./create-case'));
const CreateCaseBySubmissionPage = lazy(() => import('./create-case-by-submission'));
const CaseDetailsPage = lazy(() => import('./case-details'));

export const routes: RoutesType = [
  {
    path: Path.HOME,
    element: <HomePage />,
    title: 'Home',
    description: 'Damage Doc Home',
    permissions: [Permission.VIEW_CASE],
  },
  {
    path: Path.CASES,
    element: <CasesPage />,
    title: 'Cases',
    description: 'Cases list',
    permissions: [Permission.VIEW_CASE],
  },
  {
    path: Path.CASE_DETAILS,
    element: <CaseDetailsPage />,
    title: 'Case Details',
    description: 'Case details',
      permissions: [Permission.EDIT_CASE],
  },
  {
    path: Path.CREATE_CASE,
    element: <CreateCasePage />,
    title: 'Create Case',
    description: 'Create a new case',
    permissions: [Permission.EDIT_CASE],
  },
  {
    path: Path.CREATE_CASE_BY_SUBMISSION,
    element: <CreateCaseBySubmissionPage />,
    title: 'Create Case by Submission',
    description: 'Create a new case from a submission',
    permissions: [],
  },
];
